<gc-sidebar-nav #sidenav [loggedIn]="false"></gc-sidebar-nav>
<gc-doctor-list class="contents" [practice]="practice" (hamburgerClick)="sidenav.toggle()"></gc-doctor-list>
